import { IAccountTable } from 'models/Account';

/**
 * Matches an account by its primary Network ID or by any of its associated networks.
 *
 * Wired into the Network ID column as `customFilterAndSearch`, which material-table consults first
 * in both the per-column filter path and the global search path — so one predicate covers both.
 * A plain `field` match would only ever see the primary id.
 *
 * Kept free of React and of any table dependency so it can be unit-tested on its own.
 */
export const matchesAccountOrNetwork = (term: string, row: IAccountTable): boolean => {
    const needle = term.trim().toLowerCase();
    if (!needle) {
        return true;
    }

    const haystack = [String(row.networkId ?? ''), ...(row.associatedNetworks ?? []).flatMap((network) => [String(network.id), network.name ?? ''])];

    return haystack.some((value) => value.toLowerCase().includes(needle));
};
